import axios, {AxiosResponse} from "axios";
import Order, {OrderSendMail} from "@/model/Order";

const PATH = "/orders";

class OrderService {
  updateOrder (orderId: number, data: OrderSendMail) {
    return axios.put(`${PATH}/${orderId}`, data);
  }

  findOrdersByTerm (term: string): Promise<AxiosResponse<Array<Order>>> {
    return axios.get(`${PATH}`, {
      params: {
        term: term
      }
    });
  }
}

export default new OrderService();
